module.exports = __webpack_public_path__ + "img/shot_bigtx112503.72b8bee7.png";